const getDefaultDenom: Function = (
    defaultDenom: number | null = 100
): string => {
    if ('undefined' === typeof window) return ''
    const urlParams = new URLSearchParams(window?.location?.search)

    const amountFromUrl = urlParams.get('amount')
    if (amountFromUrl) {
        return parseFloat(urlParams.get('amount') ?? '').toFixed(2)
    }
    return defaultDenom ? defaultDenom.toFixed(2) : ''
}

export default getDefaultDenom
